module.exports = __webpack_public_path__ + "img/mpg.26b74d4.svg";